import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import {
  GLOBAL_CACHE
} from './modules/mutation_types'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: modules
})

store.subscribe((mutation) => {
  switch (mutation.type) {
    case GLOBAL_CACHE:
      sessionStorage.setItem('STORE_CACHE', JSON.stringify(store.state))
      break
    default: break
  }
})

// 恢复load之前的状态，并初始化部分数据
let storeCache = sessionStorage.getItem('STORE_CACHE')
if (storeCache) {
  let cacheData = JSON.parse(storeCache)
  store.replaceState(Object.assign({}, store.state, cacheData))
}

export default store



// WEBPACK FOOTER //
// ./src/store/index.js